import Vue from 'vue';
import Vuex from 'vuex';
import config from '@/config';
import { createStoreModule, createApiService } from '@/services';
import { getStoreData } from '@/store.config';

Vue.use(Vuex);

const store = new Vuex.Store(getStoreData());

// Create dynamic store modules
if (process.env.NODE_ENV !== 'test') {
  config.contentTypes.forEach((contentType) => {
    store.registerModule(
      contentType.name,
      createStoreModule({
        service: createApiService(contentType.endpoint),
      }),
    );
  });
}

export default store;
